import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from "../components/Terms/Hero";
import TermContent from "../components/Terms/TermContent";
import PageTitle from "../components/Terms/PageTitle";


import '../assets/Webdevelopment.css';



const Terms = () => {
	return(
		<div className="App">
			<PageTitle />
	    	<Hero />
	    	<TermContent />
	  </div>
	)
}

export default Terms;
